<!--<template>-->
<!--	<div class="element-container">-->
<!--		<div class="control-header container-header">-->
<!--			<h2>Control Device</h2>-->
<!--			<div class="buttons">-->
<!--				<button class="header-btn" @click="goBack" title="Back">-->
<!--					<Icon name="arrow-left" size="sm"/>-->
<!--				</button>-->
<!--				<button class="header-btn" @click="showEdit = true" title="Edit Device Settings">-->
<!--					<Icon name="edit" size="sm"/>-->
<!--				</button>-->
<!--			</div>-->
<!--		</div>-->
<!--		-->
<!--		<div class="container-content">-->
<!--			<div v-if="tv" class="tv-info">-->
<!--				<div class="tv-header">-->
<!--					<h3>{{ tv.name }}</h3>-->
<!--					<div class="tv-details">-->
<!--						<div v-if="tv.group?.name" class="tv-detail-line">-->
<!--							<Icon name="tv-groups" size="xs"/>-->
<!--							<span>{{ tv.group.name }}</span>-->
<!--						</div>-->
<!--						<div v-if="tv.default_app?.label && tv.default_app.key !== 'none'" class="tv-detail-line">-->
<!--							<Icon name="app" size="xs"/>-->
<!--							<span>{{ tv.default_app.label }}</span>-->
<!--						</div>-->
<!--						<div class="tv-detail-line">-->
<!--							<Icon name="id" size="xs"/>-->
<!--							<span>{{ tv.identifier_code }}</span>-->
<!--						</div>-->
<!--					</div>-->
<!--				</div>-->
<!--				-->
<!--				<div class="status-section">-->
<!--					<div class="status-indicator" :class="tv.status">-->
<!--						<div class="status-dot"></div>-->
<!--						<span>{{ tv.status === 'online' ? 'Online' : 'Offline' }}</span>-->
<!--					</div>-->
<!--				</div>-->
<!--			</div>-->
<!--			-->
<!--			<div class="control-section">-->
<!--				<h4>Quick Actions</h4>-->
<!--				<div class="action-grid">-->
<!--					<button class="action-btn power" @click="sendCommand('power_on')" :disabled="tv.status === 'offline'">-->
<!--						<Icon name="power" size="md"/>-->
<!--						<span>Refresh</span>-->
<!--					</button>-->
<!--					<button class="action-btn power-off" @click="sendCommand('power_off')" :disabled="tv.status === 'offline'">-->
<!--						<Icon name="power" size="md"/>-->
<!--						<span>// TODO?</span>-->
<!--					</button>-->
<!--				</div>-->
<!--			</div>-->
<!--			-->
<!--			<div class="app-section">-->
<!--				<h4>Launch App</h4>-->
<!--				<div class="app-grid">-->
<!--					<button-->
<!--						v-for="app in availableApps"-->
<!--						:key="app.key"-->
<!--						class="app-btn"-->
<!--						@click="launchApp(app)"-->
<!--						:disabled="tv.status === 'offline'"-->
<!--						:title="app.label"-->
<!--					>-->
<!--						<AppIcon :name="app.icon_url" class="app-icon-fill"/>-->
<!--					</button>-->
<!--				</div>-->
<!--			</div>-->
<!--			-->
<!--			<div class="actions-footer">-->
<!--				<button class="btn-back" @click="goBack">-->
<!--					<Icon name="arrow-left" size="sm"/>-->
<!--					Back-->
<!--				</button>-->
<!--			</div>-->
<!--			-->
<!--			&lt;!&ndash; Edit Modal &ndash;&gt;-->
<!--			<div v-if="showEdit" class="modal-overlay" @click="showEdit = false">-->
<!--				<div class="modal-content" @click.stop>-->
<!--					<DeviceEdit :tv="tv" @close="showEdit = false" @saved="onTvUpdated"/>-->
<!--				</div>-->
<!--			</div>-->
<!--		</div>-->
<!--	</div>-->
<!--</template>-->

<template>
	<div class="element-container">
		<div class="control-header container-header">
			<h2>{{ isGroupControl ? 'Control Group' : 'Control Device' }}</h2>
			<div class="buttons">
				<button class="header-btn" @click="goBack" title="Back">
					<Icon name="arrow-left" size="sm"/>
				</button>
				<button class="header-btn" @click="showEdit = true"
						:title="`Edit ${isGroupControl ? 'Group' : 'Device'} Settings`">
					<Icon name="edit" size="sm"/>
				</button>
			</div>
		</div>
		
		<div class="container-content">
			<!-- Device Info (existing) -->
			<div v-if="!isGroupControl && entity" class="tv-info">
				<div class="tv-header">
					<h3>{{ entity.name }}</h3>
					<div class="tv-details">
						<div v-if="entity.group?.name" class="tv-detail-line">
							<Icon name="tv-groups" size="xs"/>
							<span>{{ entity.group.name }}</span>
						</div>
						<div v-if="entity.default_app?.label && entity.default_app.key !== 'none'"
							 class="tv-detail-line">
							<Icon name="app" size="xs"/>
							<span>{{ entity.default_app.label }}</span>
						</div>
						<div class="tv-detail-line">
							<Icon name="id" size="xs"/>
							<span>{{ entity.identifier_code }}</span>
						</div>
					</div>
				</div>
				
				<div class="status-section">
					<div class="status-indicator" :class="entity.status">
						<div class="status-dot"></div>
						<span>{{ entity.status === 'online' ? 'Online' : 'Offline' }}</span>
					</div>
				</div>
			</div>
			
			<!-- Group Info -->
			<div v-if="isGroupControl && entity" class="tv-info">
				<div class="tv-header">
					<h3>{{ entity.name }}</h3>
					<div class="tv-details">
						<div v-if="entity.default_app?.label && entity.default_app.key !== 'none'"
							 class="tv-detail-line">
							<Icon name="app" size="xs"/>
							<span>{{ entity.default_app.label }}</span>
						</div>
						<div class="tv-detail-line">
							<Icon name="tv-groups" size="xs"/>
							<span>{{ entity.member_count }} device{{ entity.member_count === 1 ? '' : 's' }}</span>
						</div>
					</div>
				</div>
				
				<!-- Collapsible Device List -->
				<div class="group-devices">
					<button class="devices-toggle" @click="devicesExpanded = !devicesExpanded">
						<Icon :name="devicesExpanded ? 'arrow-down' : 'arrow-right'" size="xs"/>
						<span>{{ entity.member_count }} Device{{ entity.member_count === 1 ? '' : 's' }}</span>
					</button>
					
					<div v-if="devicesExpanded" class="devices-list">
						<div v-for="device in entity.members" :key="device.id" class="device-item">
							<Icon name="tv" size="xs"/>
							<span class="device-name">{{ device.name }}</span>
							<div class="device-status" :class="device.status">
								<div class="status-dot"></div>
								<span>{{ device.status === 'online' ? 'Online' : 'Offline' }}</span>
							</div>
						</div>
					</div>
				</div>
			</div>
			
			<!-- Quick Actions (same for both) -->
			<div class="control-section">
				<h4>Quick Actions</h4>
				<div class="action-grid">
					<button class="action-btn power" @click="sendCommand('power_on')" :disabled="!canSendCommands">
						<Icon name="power" size="md"/>
						<span>Power On</span>
					</button>
					<button class="action-btn power-off" @click="sendCommand('power_off')" :disabled="!canSendCommands">
						<Icon name="power" size="md"/>
						<span>Power Off</span>
					</button>
				</div>
			</div>
			
			<!-- Launch App (same for both) -->
			<div class="app-section">
				<h4>Launch App</h4>
				<div class="app-grid">
					<button
							v-for="app in availableApps"
							:key="app.key"
							class="app-btn"
							@click="launchApp(app)"
							:disabled="!canSendCommands"
							:title="app.label"
					>
						<AppIcon :name="app.icon_url" class="app-icon-fill"/>
					</button>
				</div>
			</div>
			
			<div class="actions-footer">
				<button class="btn-back" @click="goBack">
					<Icon name="arrow-left" size="sm"/>
					Back
				</button>
			</div>
			
			<!-- Edit Modal -->
			<div v-if="showEdit" class="modal-overlay" @click="showEdit = false">
				<div class="modal-content" @click.stop>
					<GroupEdit
							v-if="isGroupControl"
							:group="entity"
							@close="showEdit = false"
							@saved="onEntityUpdated"
							@deleted="onEntityDeleted"
					/>
					<DeviceEdit
							v-else
							:tv="entity"
							@close="showEdit = false"
							@saved="onEntityUpdated"
							@deleted="onEntityDeleted"
					/>
				</div>
			</div>
		</div>
	</div>
</template>

<script setup>
import {computed, onMounted, ref} from 'vue'
import {useMainStore} from '../store/main'
import {useRoute, useRouter} from 'vue-router'
import DeviceEdit from './DeviceEdit.vue'
import GroupEdit from "./GroupEdit.vue";
import Icon from './Icon.vue'
import AppIcon from './AppIcon.vue'

const store = useMainStore()
const route = useRoute()
const router = useRouter()

// Handle both device and group routes
const isGroupControl = computed(() => route.path.includes('/control/group/'))
const entityId = route.params.tvId || route.params.groupId

// Get either TV or Group based on route
const entity = computed(() => {
	if (isGroupControl.value) {
		return store.groups.find(g => g.id == entityId)
	} else {
		return store.pairedTVs.find(t => t.id == entityId)
	}
})

const tvId = route.params.tvId
const showEdit = ref(false)
const devicesExpanded = ref(false)

// const tv = computed(() =>
// 		store.pairedTVs.find(t => t.id == tvId)
// )

const availableApps = computed(() => store.apps)

function launchApp(app) {
	sendCommand('launch_app', {app: app.key})
}

const canSendCommands = computed(() => {
	if (isGroupControl.value) {
		// For groups, check if any device is online
		return entity.value?.members?.some(device => device.status === 'online') || false
	} else {
		// For devices, check device status
		return entity.value?.status === 'online'
	}
})

// Update functions
function sendCommand(command, params = {}) {
	if (!entity.value || !canSendCommands.value) return
	
	const endpoint = isGroupControl.value
			? `/api/control/group/${entityId}`
			: `/api/control/tv/${entityId}`
	
	fetch(endpoint, {
		method: 'POST',
		headers: {
			'Authorization': `Bearer ${sessionStorage.getItem('buzztime_token')}`,
			'Content-Type': 'application/json'
		},
		body: JSON.stringify({command, ...params})
	}).then(response => {
		if (response.ok) {
			console.log(`Command ${command} sent successfully`)
		} else {
			response.json().then(error => {
				alert(`Failed to send command: ${error.message}`)
			})
		}
	}).catch(error => {
		console.error('Command error:', error)
		alert('Failed to send command')
	})
}

function onEntityUpdated(updatedEntity) {
	if (isGroupControl.value) {
		const index = store.groups.findIndex(g => g.id === updatedEntity.id)
		if (index !== -1) {
			store.groups[index] = updatedEntity
		}
	} else {
		const index = store.pairedTVs.findIndex(t => t.id === updatedEntity.id)
		if (index !== -1) {
			store.pairedTVs[index] = updatedEntity
		}
	}
}

function onEntityDeleted(deletedEntity) {
	if (isGroupControl.value) {
		const index = store.groups.findIndex(g => g.id === deletedEntity.id)
		if (index !== -1) {
			store.groups.splice(index, 1)
		}
		router.push('/')
	} else {
		const index = store.pairedTVs.findIndex(t => t.id === deletedEntity.id)
		if (index !== -1) {
			store.pairedTVs.splice(index, 1)
		}
		router.push('/')
	}
}

// function sendCommand(command, params = {}) {
// 	if (!tv.value || tv.value.status === 'offline') return
//
// 	fetch(`/api/control/tv/${tvId}`, {
// 		method: 'POST',
// 		headers: {
// 			'Authorization': `Bearer ${sessionStorage.getItem('buzztime_token')}`,
// 			'Content-Type': 'application/json'
// 		},
// 		body: JSON.stringify({command, ...params})
// 	}).then(response => {
// 		if (response.ok) {
// 			console.log(`Command ${command} sent successfully`)
// 		} else {
// 			response.json().then(error => {
// 				alert(`Failed to send command: ${error.message}`)
// 			})
// 		}
// 	}).catch(error => {
// 		console.error('Command error:', error)
// 		alert('Failed to send command')
// 	})
// }

// function onTvUpdated(updatedTv) {
// 	const index = store.pairedTVs.findIndex(t => t.id === updatedTv.id)
// 	if (index !== -1) {
// 		store.pairedTVs[index] = updatedTv
// 	}
// }

function goBack() {
	router.push('/home')
}

onMounted(async () => {
	if (store.apps.length === 0) {
		await store.loadApps()
	}
})
</script>

<style scoped>
.control-header h2 {
	margin: 0;
	color: var(--color-text);
}

.buttons {
	display: flex;
	justify-content: space-around;
	gap: var(--spacing-sm);
}

.header-btn {
	display: inline-flex;
	align-items: center;
	justify-content: center;
	height: 3rem;
	width: 3rem;
	padding: var(--spacing-sm) var(--spacing-md);
	background: var(--color-popup-element-2);
	color: var(--color-text);
	border: var(--border-thin) var(--color-border);
	border-radius: var(--border-radius-md);
	font-size: var(--font-size-sm);
	cursor: pointer;
	transition: all var(--transition-fast);
}

.header-btn:hover {
	background: var(--color-popup-light);
	border-color: var(--color-primary);
}

.tv-info {
	background: var(--color-popup-2);
	border: var(--border-thin) var(--color-border);
	border-radius: var(--border-radius-lg);
	padding: var(--spacing-lg);
}

.tv-header h3 {
	margin: 0 0 var(--spacing-sm) 0;
	color: var(--color-text);
}

.tv-details {
	display: flex;
	flex-direction: row;
	justify-content: space-between;
	gap: var(--spacing-xs);
}

.tv-detail-line {
	display: flex;
	align-items: center;
	gap: var(--spacing-sm);
	font-size: var(--font-size-sm);
	color: var(--color-text-secondary);
}

.status-indicator {
	display: inline-flex;
	align-items: center;
	gap: var(--spacing-sm);
	margin-top: var(--spacing-md);
	padding: 0 var(--spacing-md);
	border-radius: var(--border-radius-md);
	font-size: var(--font-size-sm);
	font-weight: var(--font-weight-medium);
}

.status-indicator.online {
	color: var(--color-success);
}

.status-indicator.offline {
	color: var(--color-error);
}

.status-dot {
	width: 8px;
	height: 8px;
	border-radius: 50%;
}

.status-indicator.online .status-dot {
	background: var(--color-success);
}

.status-indicator.offline .status-dot {
	background: var(--color-error);
}

.control-section h4,
.app-section h4 {
	margin-bottom: var(--spacing-md);
	color: var(--color-text);
}

.action-grid {
	display: grid;
	grid-template-columns: repeat(2, 1fr);
	gap: var(--spacing-md);
}

.action-btn {
	display: flex;
	flex-direction: column;
	align-items: center;
	gap: var(--spacing-xs);
	padding: var(--spacing-lg);
	background: var(--color-popup-element-2);
	color: var(--color-text);
	border: var(--border-thin) var(--color-border);
	border-radius: var(--border-radius-md);
	cursor: pointer;
	transition: all var(--transition-fast);
}

.action-btn:hover:not(:disabled) {
	background: var(--color-popup-light);
	border-color: var(--color-primary);
	transform: translateY(-1px);
}

.action-btn:disabled {
	opacity: 0.5;
	filter: brightness(0.6);
	cursor: not-allowed;
}

.app-grid {
	display: grid;
	grid-template-columns: repeat(auto-fit, minmax(40%, 1fr));
	gap: var(--spacing-md);
}

.app-btn {
	position: relative;
	aspect-ratio: 1 / 1;
	padding: 0;
	background: var(--color-popup-element);
	border: var(--border-thin) var(--color-border);
	border-radius: var(--border-radius-md);
	cursor: pointer;
	transition: all var(--transition-fast);
	overflow: hidden; /* Ensures icon doesn't overflow */
}

.app-btn:hover:not(:disabled) {
	background: var(--color-popup-light);
	border-color: var(--color-primary);
	transform: translateY(-2px);
}

.app-btn:disabled {
	opacity: 0.5;
	filter: brightness(0.6);
	cursor: not-allowed;
}

.app-icon-fill {
	position: absolute;
	top: 0;
	left: 0;
	width: 100%;
	height: 100%;
	object-fit: cover; /* Ensures the image fills the container */
	border-radius: var(--border-radius-md);
}

.actions-footer {
	display: flex;
	justify-content: center;
	margin-top: var(--spacing-xl);
}

.btn-back {
	display: inline-flex;
	align-items: center;
	gap: var(--spacing-xs);
	padding: var(--spacing-md) var(--spacing-lg);
	background: var(--color-popup-element);
	color: var(--color-text);
	border: var(--border-thin) var(--color-border);
	border-radius: var(--border-radius-md);
	cursor: pointer;
	transition: all var(--transition-fast);
	font-size: var(--font-size-sm);
}

.btn-back:hover {
	background: var(--color-popup-light);
}

.not-found {
	text-align: center;
	padding: var(--spacing-3xl) var(--spacing-lg);
}

.not-found p {
	color: var(--color-text-secondary);
	margin: var(--spacing-md) 0;
}

.modal-overlay {
	position: fixed;
	top: 0;
	left: 0;
	right: 0;
	bottom: 0;
	background: rgba(0, 0, 0, 0.7);
	display: flex;
	align-items: center;
	justify-content: center;
	z-index: 1000;
}

.modal-content {
	width: 90%;
	max-width: 500px;
	max-height: 90vh;
	overflow-y: auto;
}

.group-devices {
	margin-top: var(--spacing-md);
	border-top: var(--border-thin) var(--color-border);
	padding-top: var(--spacing-md);
}

.devices-toggle {
	display: flex;
	align-items: center;
	gap: var(--spacing-xs);
	background: transparent;
	border: none;
	color: var(--color-text);
	cursor: pointer;
	font-size: var(--font-size-sm);
	padding: var(--spacing-xs) 0;
	width: 100%;
	text-align: left;
}

.devices-toggle:hover {
	color: var(--color-primary);
}

.devices-list {
	margin-top: var(--spacing-sm);
	display: flex;
	flex-direction: column;
	gap: var(--spacing-xs);
}

.device-item {
	display: flex;
	align-items: center;
	gap: var(--spacing-sm);
	padding: var(--spacing-xs) var(--spacing-sm);
	background: var(--color-surface-elevated);
	border: var(--border-thin) var(--color-border);
	border-radius: var(--border-radius-md);
}

.device-name {
	flex: 1;
	text-align: start;
	margin-left: var(--spacing-sm);
	font-size: var(--font-size-sm);
}

.device-status {
	display: flex;
	align-items: center;
	gap: var(--spacing-xs);
	font-size: var(--font-size-xs);
}

.device-status .status-dot {
	position: relative;
	width: 0.5rem;
	height: 0.5rem;
	border-radius: 50%;
	border: none;
}

.device-status.online .status-dot {
	background-color: var(--color-success);
}

.device-status.offline .status-dot {
	background-color: var(--color-error);
}
</style>